import { UseFormReturnType, isEmail, isNotEmpty, useForm } from '@mantine/form'
import { UpdateLocationRequest } from '@v2/domains/location/location.types'

import { STATES } from 'src/common/config'

import { ICreateClinicForm } from '../clinics.type'
import { useClinicsMutations } from './useClinicsMutations.hook'

export interface ICreateClinicHook {
  form: UseFormReturnType<ICreateClinicForm & UpdateLocationRequest>
  onSubmit: () => void
  isLoading: boolean
  ALL_STATES: { label: string; value: string }[]
}

export const useCreateClinicLocation = (
  clinicName: string,
  clinicProgram: string,
): ICreateClinicHook => {
  const { createClinic, isLoadingCreate } = useClinicsMutations()

  const form = useForm<any>({
    mode: 'uncontrolled',
    initialValues: {
      name: clinicName,
      program: clinicProgram,
      location: {
        name: '',
        email: '',
        businessDays: '',
        phoneNumber: '',
        languages: [],
        address: {
          streetAddress: '',
          city: '',
          state: '',
          zipCode: '',
          parkingSpace: '',
        },
      },
    },
    validateInputOnBlur: true,
    validate: {
      name: isNotEmpty('Name is required'),
      program: isNotEmpty('Clinic Type is required'),
      location: {
        businessDays: isNotEmpty(
          'Location Operation Days & Hours are required',
        ),
        name: isNotEmpty('Location Name is required'),
        phoneNumber: isNotEmpty('Phone Number is required'),
        languages: isNotEmpty('Spoken Languages is required'),
        email: (value?: string) => {
          if (!value || value.trim() === '') {
            return null
          }
          return isEmail('Invalid email')(value)
        },
        address: {
          streetAddress: isNotEmpty('Street Address is required'),
          city: isNotEmpty('City is required'),
          state: isNotEmpty('State is required'),
          zipCode: isNotEmpty('Zip Code is required'),
        },
      },
    },
  })

  const onSubmit = () => {
    form.onSubmit(async (values) => {
      await createClinic({
        name: values.name,
        program: values.program,
        locations: [values.location],
      })
    })()
  }

  const ALL_STATES = Object.values(STATES).map(({ value, match }) => {
    return {
      label: value,
      value: match[0],
    }
  })

  return {
    form,
    onSubmit,
    isLoading: isLoadingCreate,
    ALL_STATES,
  }
}
